<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="content flex Flexjustify">
      <div class="content_box flex FlexBetween">
        <div class="left_box">
          <div class="left_title">消息</div>
          <div class="menu_box">
            <div class="menu_one flex Flexalign mar_top_20 cursor_pointer" v-for="(item, index) in menuList"
              :key="index" @click="changeMenu(item)">
              <el-image class="email_icon"
                :src="iconPath(item.value == selectValue ? item.activeIcon : item.icon)"></el-image>
              <div class="menu_label mar_left_10" :class="[item.value == selectValue ? 'active_text' : '']">
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
        <systemMessage v-if="selectValue == 1"></systemMessage>
        <comment v-if="selectValue == 2"></comment>
        <giveUp v-if="selectValue == 3"></giveUp>
        <!-- <div class="content_right">
          <div class="top_banner_right flex flexcolumn">
          </div>
          <recommendCourseList></recommendCourseList>
        </div> -->
      </div>
    </div>
  </moe-page>
</template>

<script>
import systemMessage from "./components/systemMessage.vue";
import comment from "./components/comment.vue";
import giveUp from "./components/giveUp.vue";
// import recommendCourseList from "@/views/course/components/recommendCourseList.vue";
export default {
  name: "GjkcH5Index",
  components: {
    systemMessage,
    comment,
    giveUp,
    // recommendCourseList,
  },

  data() {
    return {
      menuList: [
        {
          icon: "email_icon.png",
          label: "系统消息",
          activeIcon: "email_active_icon.png",
          value: 1,
        },
        {
          icon: "message_icon.png",
          label: "评论",
          activeIcon: "message_active_icon.png",
          value: 2,
        },
        {
          icon: "give_up_icon.png",
          label: "点赞",
          activeIcon: "give_up_active_icon.png",
          value: 3,
        },
      ],
      selectValue: 1,
      rankList: [
        {
          courseImg: "course_img2.png",
          title: "实数的概念",
          rateValue: 5,
          price: 1999.99,
          classHour: 34,
          institutionName: "圆梦培训机构",
        },
        {
          courseImg: "course_img2.png",
          title: "实数的概念",
          rateValue: 5,
          price: 1999.99,
          classHour: 34,
          institutionName: "圆梦培训机构",
        },
        {
          courseImg: "course_img2.png",
          title: "实数的概念",
          rateValue: 4,
          price: 1999.99,
          classHour: 34,
          institutionName: "圆梦培训机构",
        },
        {
          courseImg: "course_img2.png",
          title: "实数的概念",
          rateValue: 5,
          price: 1999.99,
          classHour: 34,
          institutionName: "圆梦培训机构",
        },
        {
          courseImg: "course_img2.png",
          title: "实数的概念",
          rateValue: 5,
          price: 1999.99,
          classHour: 34,
          institutionName: "圆梦培训机构",
        },
      ],
    };
  },

  mounted() { },

  methods: {
    changeMenu(info) {
      this.selectValue = info.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .content_box {
    width: $pageMainWidth;
    margin-top: 20px;

    .left_box {
      width: 181px;
      height: 404px;
      background: #ffffff;
      border-radius: 10px;
      padding: 15px 10px;
      box-sizing: border-box;

      .left_title {
        font-weight: bold;
        font-size: 18px;
        color: #111111;
      }

      .menu_box {
        .menu_one {
          .email_icon {
            width: 20px;
            height: 20px;
          }

          .menu_label {
            color: #666666;
          }

          .active_text {
            color: #13d6aa;
          }
        }
      }
    }

    .content_right {
      width: calc($pageMainWidth - 868px);

      .top_banner_right {
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        // padding: 12px;
        // height: 530px;
        margin-bottom: 10px;
      }

      .course_list {
        margin-top: 10px;
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        padding: 12px;

        .recommend {
          font-weight: bold;
          font-size: 18px;
          color: #111111;
        }

        .more_btn {
          color: rgba(102, 102, 102, 1);
        }

        .course_one {
          background: #ffffff;
          border-radius: 10px;
          width: 100%;
          margin-top: 15px;

          .course_title {
            font-weight: bold;
            font-size: 18px;
            color: #111111;
          }

          .course_rank_list {
            .course_one_img {
              width: 100px;
              height: 70px;
            }

            .course_info {
              height: 70px;
              margin-left: 11px;

              .course_rate {
                :deep(.el-rate .el-rate__icon) {
                  margin-right: 0;
                }

                .course_price {
                  color: #ff6619;
                  font-size: 18px;
                  font-weight: 600;

                  .course_price_unit {
                    font-size: 16px;
                    font-weight: 400;
                  }
                }
              }

              .course_online_info {
                .course_online {
                  font-size: 14px;
                  color: #999999;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
